import { portalRoutes } from "@/router/routes/portalRoutes";

export const ADD_DEVICE_TOTAL_STEPS = 4;

interface AddDeviceStep {
  /** 1-based position in the flow. */
  step: number;
  /** i18n key of the step name, relative to the `add-device` key prefix. */
  label: string;
  /** i18n key of the step's explanatory copy. */
  description?: string;
}

/**
 * The four steps of the add-device flow, keyed by the substep segment of
 * `/portal/add-device/:step/:substep`. `sim-verification` belongs to the SIM
 * step and therefore shares its entry.
 */
export const addDeviceStepMapping: Record<string, AddDeviceStep> = {
  "sim-selection": {
    step: 1,
    label: "steps.sim-selection.label",
  },
  "sim-verification": {
    step: 1,
    label: "steps.sim-selection.label",
  },
  "rate-selection": { step: 2, label: "steps.rate-selection.label" },
  "number-porting": {
    step: 3,
    label: "steps.number-porting.label",
    description: "steps.number-porting.description",
  },
  checkout: { step: 4, label: "steps.checkout.label" },
};

/** Route of each substep — powers the stepper's step-jump dropdown. */
export const addDeviceStepPaths: Record<string, string> = {
  "sim-selection": portalRoutes.addDevice.simSelection,
  "rate-selection": portalRoutes.addDevice.rateSelection,
  "number-porting": portalRoutes.addDevice.numberPorting,
  checkout: portalRoutes.addDevice.checkout,
};
